import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import download from "../../../helpers/download";
import { getRptAlertaLista } from "./services";

const initialState: any = {
  status: "",
  noContent: true
};

export const actionGetRptAlertaLista: any = createAsyncThunk<any, any>(
  "ACTION_GET_GET_RPT_ALERTA_LISTA",
  async (data) => {
    const result = await getRptAlertaLista(data);

    download(result, {ext: data.reportType, fileName: `relatorio-lista-de-alertas`});
    
    return result
  }
);

const sliceGetRptAlertaLista = createSlice({
  name: "GET_RPT_ALERTA_LISTA",
  initialState,
  reducers: {},
  extraReducers: {
    [actionGetRptAlertaLista.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetRptAlertaLista.fulfilled]: (state, { payload: {status} }) => {
      state.status = "success";
      state.noContent = status === 204
    },
    [actionGetRptAlertaLista.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetRptAlertaLista.reducer
